export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9774.d60cd232.jpg";